/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SavedInputs */



/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Common_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_saved = /** @type {((inputs?: Common_SavedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SavedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistré")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvato")
	return /** @type {LocalizedString} */ ("Saved")
});